export const p = console.log.bind(console);



/** WEBPACK FOOTER **
 ** ./client/p.ts
 **/